var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapPopupArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn__switch",
    "data-name": "btn_ switch",
    transform: "translate(-1101.75 -976.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1123.751 976.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_114",
    "data-name": "\\uD328\\uC2A4 114",
    d: "M978.995,3380.584a1,1,0,0,1-.707-1.707l6.293-6.293-6.293-6.293a1,1,0,0,1,1.414-1.414l7,7a1,1,0,0,1,0,1.416l-7,7A1,1,0,0,1,978.995,3380.584Z",
    transform: "translate(-977.995 -3364.584)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_649",
    "data-name": "\\uC120 649",
    x2: 21.06,
    transform: "translate(1102.75 984.625)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapPopupArrow);
export default __webpack_public_path__ + "static/media/swap_popup_arrow.8e532d7b.svg";
export { ForwardRef as ReactComponent };